import { useTheme } from '@mui/material/styles';
import { LoginPage as SharedLoginPage } from '@warrcloud/shared-components';
import type { FC } from 'react';
import { useCallback } from 'react';

import { CHIRP_APP_URL, COGNITO_CLIENT_ID, COGNITO_URL } from 'config';
import { useAuth } from 'contexts/AuthContext';

const LoginPage: FC = () => {
  const theme = useTheme();
  const { login, isLoginLoading } = useAuth();

  const handleAuthCodeReceived = useCallback(
    (code: string): void => {
      login(code);
    },
    [login]
  );

  return (
    <SharedLoginPage
      appUrl={CHIRP_APP_URL ?? ''}
      cognitoUrl={COGNITO_URL ?? ''}
      cognitoClientId={COGNITO_CLIENT_ID ?? ''}
      appDisplayName="Chirp"
      onAuthCodeReceived={handleAuthCodeReceived}
      isLoginLoading={isLoginLoading}
      primaryColor={theme.palette.primary.main}
    />
  );
};

export default LoginPage;
